import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/pay/cash.png'
import _imports_1 from '@/assets/pay/manual.png'
import _imports_2 from '@/assets/pay/paylater.png'


const _withScopeId = n => (_pushScopeId("data-v-49a492a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-money-bill py-icon-color" }, null, -1))
const _hoisted_3 = { class: "row text-center" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = {
  key: 0,
  class: "pay-size-bx"
}
const _hoisted_6 = { class: "py-span" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Cash ")
const _hoisted_9 = {
  key: 1,
  class: "pay-size-bx"
}
const _hoisted_10 = { class: "py-span" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Card ")
const _hoisted_13 = {
  key: 2,
  class: "pay-size-bx"
}
const _hoisted_14 = { class: "py-span" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Cheque ")
const _hoisted_17 = {
  key: 3,
  class: "pay-size-bx"
}
const _hoisted_18 = { class: "py-span" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Credit", -1))
const _hoisted_21 = {
  key: 4,
  class: "pay-size-bx"
}
const _hoisted_22 = { class: "py-span" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Pay Later ")
const _hoisted_25 = { class: "row py-description" }
const _hoisted_26 = {
  style: {"height":"0.2em","background-color":"#fff"},
  class: "col-md-12"
}
const _hoisted_27 = { class: "col-md-2 col-sm-12 content-height p-pl-1 p-pr-0" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "mt-2" }
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "mt-2" }
const _hoisted_32 = ["value"]
const _hoisted_33 = ["hidden"]
const _hoisted_34 = { class: "content-height" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-file-o py-icon-color",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode(" Key Pad ")
], -1))
const _hoisted_36 = { class: "btn-group btn-group-lg" }
const _hoisted_37 = { class: "btn-group btn-group-lg" }
const _hoisted_38 = { class: "btn-group btn-group-lg" }
const _hoisted_39 = { class: "btn-group btn-group-lg" }
const _hoisted_40 = {
  class: "btn-group btn-group-lg",
  style: {"margin-top":"1px"}
}
const _hoisted_41 = { class: "col-md-4 col-sm-12" }
const _hoisted_42 = {
  key: 0,
  class: "content-height"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-id-card py-icon-color",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode(" Add Card Payments Manually ")
], -1))
const _hoisted_44 = { class: "transactions-card-manual" }
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " Card Type", -1))
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " Card No (Last 4 digits)", -1))
const _hoisted_49 = {
  key: 1,
  class: "content-height"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "transactions" }, [
  /*#__PURE__*/_createElementVNode("h5", null, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "pi pi-money-bill py-icon-color",
      "aria-hidden": "true"
    }),
    /*#__PURE__*/_createTextVNode(" Add Cash ")
  ])
], -1))
const _hoisted_51 = { class: "col-md-12 p-0" }
const _hoisted_52 = {
  key: 2,
  class: "content-height"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-id-card py-icon-color",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode(" Add Cheque Payment ")
], -1))
const _hoisted_54 = { class: "transactions-card-manual" }
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " Reference", -1))
const _hoisted_57 = {
  key: 3,
  class: "content-height"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-id-card py-icon-color",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode(" Add to Supplier Credit ")
], -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "transactions-card-manual" }, null, -1))
const _hoisted_60 = { class: "col-md-3 col-sm-12" }
const _hoisted_61 = { class: "parent-container" }
const _hoisted_62 = { class: "content-height-payment" }
const _hoisted_63 = { class: "payments" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-money-bill py-icon-color",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode(" Payment Methods ")
], -1))
const _hoisted_65 = {
  id: "customer_payment_method_manual",
  class: "table table-bordered table-striped py-list-collections table-hover"
}
const _hoisted_66 = { class: "text-left" }
const _hoisted_67 = { class: "text-left" }
const _hoisted_68 = { id: "history_total_cash" }
const _hoisted_69 = ["id", "onClick"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times" }, null, -1))
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = { key: 0 }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"background-color":"#E0A800","color":"#000"} }, " Latency(Days) ", -1))
const _hoisted_74 = {
  class: "text-left",
  style: {"background-color":"#E0A800","color":"#000"}
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"background-color":"green","color":"#fff"} }, " Total ", -1))
const _hoisted_76 = {
  class: "text-left",
  style: {"background-color":"green","color":"#fff"}
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "payment-done-ui" }, null, -1))
const _hoisted_78 = { class: "confirmation-content" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_80 = /*#__PURE__*/_createTextVNode("Are you sure to cancel ? You will lost the payments of amount ")
const _hoisted_81 = { class: "confirmation-content" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_83 = /*#__PURE__*/_createTextVNode("Are you sure to continue this invoice. The remaining balance for this invoice is ")
const _hoisted_84 = /*#__PURE__*/_createTextVNode(" ? ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      visible: _ctx.paymentDialog,
      "onUpdate:visible": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.paymentDialog) = $event)),
      style: { width: '100vw' },
      modal: true,
      closable: true,
      position: "top",
      onHide: _ctx.confirmPaymentCancel,
      class: "p-fluid p-m-0 p-dialog-maximized",
      showHeader: true
    }, {
      header: _withCtx(() => [
        _createElementVNode("h6", _hoisted_1, [
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.cashPayment)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                  _createElementVNode("label", _hoisted_6, [
                    _hoisted_7,
                    _hoisted_8,
                    _createVNode(_component_RadioButton, {
                      modelValue: _ctx.paymentMethodType,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paymentMethodType) = $event)),
                      value: "Cash",
                      id: "CashOption"
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.cardPayment)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, [
                    _hoisted_11,
                    _hoisted_12,
                    _createVNode(_component_RadioButton, {
                      modelValue: _ctx.paymentMethodType,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.paymentMethodType) = $event)),
                      value: "Manual",
                      id: "ManualOption"
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.chequePayment)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, [
                    _hoisted_15,
                    _hoisted_16,
                    _createVNode(_component_RadioButton, {
                      modelValue: _ctx.paymentMethodType,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.paymentMethodType) = $event)),
                      value: "Cheque"
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.paySupplierCredit)
              ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, [
                    _hoisted_19,
                    _hoisted_20,
                    _createVNode(_component_RadioButton, {
                      modelValue: _ctx.paymentMethodType,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.paymentMethodType) = $event)),
                      value: "SupplierCredit"
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.restriction != 'Yes' && _ctx.paymentOptionType !='Transaction' && _ctx.payLater)
              ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                  _createElementVNode("label", _hoisted_22, [
                    _hoisted_23,
                    _hoisted_24,
                    _createVNode(_component_RadioButton, {
                      modelValue: _ctx.paymentMethodType,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.paymentMethodType) = $event)),
                      value: "Pay Later"
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            (_ctx.progressBar)
              ? (_openBlock(), _createBlock(_component_ProgressBar, {
                  key: 0,
                  mode: "indeterminate",
                  style: {"height":"0.2em"}
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("h5", null, [
              _createTextVNode(" (" + _toDisplayString(_ctx.currency) + ") Amount Due ", 1),
              _createElementVNode("input", {
                type: "text",
                value: _ctx.fixLength(_ctx.paymentRounding),
                readonly: "",
                class: "form-control py-customize-bx mt-1 py-balance-due"
              }, null, 8, _hoisted_28)
            ]),
            _createElementVNode("h5", _hoisted_29, [
              _createTextVNode(" (" + _toDisplayString(_ctx.currency) + ") " + _toDisplayString(_ctx.receivedTxt) + " ", 1),
              _createElementVNode("input", {
                style: {"color":"green"},
                type: "number",
                readonly: "",
                value: _ctx.fixLength(_ctx.paymentAction.tendered),
                class: "form-control py-customize-bx mt-1"
              }, null, 8, _hoisted_30)
            ]),
            _createElementVNode("h5", _hoisted_31, [
              _createTextVNode(" (" + _toDisplayString(_ctx.currency) + ") Balance ", 1),
              _createElementVNode("input", {
                type: "number",
                readonly: "",
                value: _ctx.fixLength(_ctx.changeAmount),
                class: "form-control py-customize-bx mt-1"
              }, null, 8, _hoisted_32)
            ])
          ]),
          _createElementVNode("div", {
            class: "col-md-3 col-sm-12",
            hidden: _ctx.hideKeyPad
          }, [
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("div", {
                class: "btn-group-vertical text-center",
                role: "group",
                "aria-label": "Basic example",
                id: "amtDue",
                onKeydown: _cache[18] || (_cache[18] = _withKeys(_withModifiers(($event: any) => (_ctx.focusNext('Manual', $event, null)), ["prevent"]), ["right"]))
              }, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.amountNumpad(1))),
                    class: "btn-numpad col-sm-4"
                  }, " 1 "),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.amountNumpad(2))),
                    class: "btn-numpad col-sm-4"
                  }, " 2 "),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.amountNumpad(3))),
                    class: "btn-numpad col-sm-4"
                  }, " 3 ")
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.amountNumpad(4))),
                    class: "btn-numpad"
                  }, " 4 "),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.amountNumpad(5))),
                    class: "btn-numpad"
                  }, " 5 "),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.amountNumpad(6))),
                    class: "btn-numpad"
                  }, " 6 ")
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.amountNumpad(7))),
                    class: "btn-numpad"
                  }, " 7 "),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.amountNumpad(8))),
                    class: "btn-numpad"
                  }, " 8 "),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.amountNumpad(9))),
                    class: "btn-numpad"
                  }, " 9 ")
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.amountNumpad('.'))),
                    class: "btn-numpad"
                  }, " . "),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.amountNumpad(0))),
                    class: "btn-numpad"
                  }, " 0 "),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.amountNumpad('del'))),
                    class: "btn-numpad-danger"
                  }, " Del ")
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_Button, {
                    label: "Exact",
                    icon: "pi pi-ticket",
                    class: "p-button-lg p-button-primary p-4 button",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.exactAmount())),
                    disabled: _ctx.paymentMethodType == ''
                  }, null, 8, ["disabled"])
                ])
              ], 32)
            ])
          ], 8, _hoisted_33),
          _createElementVNode("div", _hoisted_41, [
            (_ctx.paymentMethodType == 'Manual')
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _hoisted_43,
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _hoisted_46,
                      _createVNode(_component_Dropdown, {
                        options: _ctx.methodList,
                        modelValue: _ctx.cardType,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.cardType) = $event)),
                        optionLabel: "cardName",
                        id: "cardDropdown"
                      }, null, 8, ["options", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _createVNode(_component_InputText, {
                        id: "accountNoInput",
                        placeholder: "e.g 3217",
                        onInput: _cache[20] || (_cache[20] = ($event: any) => (_ctx.validateUnit($event))),
                        modelValue: _ctx.accountNo,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.accountNo) = $event)),
                        modelModifiers: { trim: true }
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode(_component_Button, {
                    label: "Add Card Payment",
                    icon: "pi pi-money-bill",
                    onClick: _ctx.addManualAmount,
                    class: "p-button-lg p-button-warning p-4"
                  }, null, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.paymentMethodType == 'Cash')
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_Button, {
                      ref: "addCashButton",
                      label: !(_ctx.partiallyPaid && _ctx.paymentAction.tendered == 0)? 'Add Cash':'Continue (Partially Paid)',
                      icon: "pi pi-money-bill",
                      class: "p-button-lg p-button-warning p-4",
                      onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.addCashAmount())),
                      disabled: _ctx.paymentMethodType == ''
                    }, null, 8, ["label", "disabled"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.paymentMethodType == 'Cheque')
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _hoisted_53,
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _hoisted_56,
                      _createVNode(_component_InputText, {
                        id: "accountNoInputCheque",
                        modelValue: _ctx.accountNoCheque,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.accountNoCheque) = $event)),
                        modelModifiers: { trim: true }
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode(_component_Button, {
                    label: "Add Cheque Payment",
                    icon: "pi pi-money-bill",
                    onClick: _ctx.addChequeAmount,
                    class: "p-button-lg p-button-warning p-4"
                  }, null, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.paymentMethodType == 'SupplierCredit')
              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                  _hoisted_58,
                  _hoisted_59,
                  _createVNode(_component_Button, {
                    label: "Add to Supplier Credit",
                    icon: "pi pi-money-bill",
                    onClick: _ctx.addSupplierCreditAmount,
                    class: "p-button-lg p-button-warning p-4"
                  }, null, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _hoisted_64,
                  _createElementVNode("table", _hoisted_65, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentList, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: item }, [
                        _createElementVNode("td", _hoisted_66, _toDisplayString(item.paymentType), 1),
                        _createElementVNode("td", _hoisted_67, [
                          _createTextVNode(_toDisplayString(_ctx.currency) + " ", 1),
                          _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.fixLength(item.transTotalAmount)), 1),
                          _createElementVNode("span", {
                            id: 'delete-pay-item-' + index,
                            onClick: ($event: any) => (_ctx.deletePayment(index, item)),
                            class: "payment_cross"
                          }, _hoisted_71, 8, _hoisted_69)
                        ])
                      ]))
                    }), 128)),
                    (_ctx.latency > 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_72, [
                          _hoisted_73,
                          _createElementVNode("td", _hoisted_74, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.latency), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", null, [
                      _hoisted_75,
                      _createElementVNode("td", _hoisted_76, [
                        _createTextVNode(_toDisplayString(_ctx.currency) + " ", 1),
                        _createElementVNode("b", null, _toDisplayString(_ctx.fixLength(_ctx.totalPaymentsReceived)), 1)
                      ])
                    ])
                  ])
                ]),
                _hoisted_77,
                _createVNode(_component_Button, {
                  ref: "doneButton",
                  label: "Done",
                  id: "paymentDone",
                  icon: "pi pi-check-circle",
                  class: "p-button-lg p-button-primary p-4 done-btn",
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.confirmPayments())),
                  disabled: (this.partiallyPaid)?false:_ctx.enableDone()
                }, null, 8, ["disabled"])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onHide"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.paymentCancelDialog,
      "onUpdate:visible": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.paymentCancelDialog) = $event)),
      style: { width: '600px' },
      header: "Confirm"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          class: "p-button-text",
          onClick: _ctx.cancelPaymentConfirm
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: "Yes",
          icon: "pi pi-check",
          class: "p-button-danger",
          onClick: _ctx.closePaymentScreen
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_78, [
          _hoisted_79,
          _createElementVNode("span", null, [
            _hoisted_80,
            _createElementVNode("b", null, " LKR " + _toDisplayString(_ctx.fixLength(_ctx.totalPaymentsReceived)), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.paymentConfirmDialog,
      "onUpdate:visible": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.paymentConfirmDialog) = $event)),
      style: { width: '600px' },
      header: "Confirm"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          class: "p-button-text",
          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.paymentConfirmDialog = false))
        }),
        (_ctx.payLater)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              label: "Yes",
              icon: "pi pi-check",
              class: "p-button-danger",
              onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.emitPayments()))
            }))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_81, [
          _hoisted_82,
          _createElementVNode("span", null, [
            _hoisted_83,
            _createElementVNode("b", null, " LKR " + _toDisplayString(_ctx.fixLength(_ctx.paymentRounding)), 1),
            _hoisted_84
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}